/** MUI 图标名 -> 图标组件映射（侧边栏 & 菜单管理共用） */

import type { ReactNode } from 'react';
import {
  Dashboard, Receipt, AccountBalance, Inventory2, LocalShipping, Assignment,
  Description, Router, Category, Shield, Assessment, Settings, Security,
  SmartToy, VerifiedUser, People, Menu as MenuIcon, Person, VpnKey,
  ViewModule, Business, Label, AccountTree,
  ShoppingCart, ReceiptLong, Email,
} from '@mui/icons-material';

export const iconMap: Record<string, ReactNode> = {
  // MUI 原始组件名（数据库实际存储值）
  AccountBalance: <AccountBalance />, Assignment: <Assignment />,
  Assessment: <Assessment />, Business: <Business />, Category: <Category />,
  Dashboard: <Dashboard />, Description: <Description />, Inventory2: <Inventory2 />,
  Label: <Label />, LocalShipping: <LocalShipping />, Menu: <MenuIcon />,
  People: <People />, Person: <Person />, Receipt: <Receipt />, Router: <Router />,
  Security: <Security />, Settings: <Settings />, Shield: <Shield />,
  SmartToy: <SmartToy />, VerifiedUser: <VerifiedUser />, VpnKey: <VpnKey />,
  ViewModule: <ViewModule />, AccountTree: <AccountTree />,
  ShoppingCart: <ShoppingCart />, ReceiptLong: <ReceiptLong />, Email: <Email />,
  // 别名（旧数据兼容）
  Finance: <AccountBalance />, Container: <Inventory2 />, Shipping: <LocalShipping />,
  Customs: <Assignment />, Document: <Description />, IoT: <Router />, Claim: <Shield />,
  Risk: <Assessment />, Config: <Settings />, RBAC: <Security />, AI: <SmartToy />,
  Buyers: <People />,
};

/** 将 icon 字符串解析为 MUI 图标组件 */
export function resolveIcon(name?: string): ReactNode {
  if (name && iconMap[name]) return iconMap[name];
  return <Label />;
}

/** 所有可用图标名列表（供下拉选择使用） */
export const iconOptions = Object.keys(iconMap);
